import { UserType } from 'functions/src/types'
import React from 'react'
import { Keyboard, StyleSheet } from 'react-native'
import { ScrollView } from 'react-native-gesture-handler'

import { UserRow } from 'partials/UserRow'

import { Box } from 'widgets/Box'

import commonStyles from 'utils/styles/commonStyles'

interface SearchResultsProps {
  matchingUsers: UserType[]
  onUserPress: (user: UserType) => void
  visible: boolean
  maxHeight?: number | string
  width?: number | string
}

const styles = StyleSheet.create({
  searchResultsContainer: {
    borderTopWidth: 0,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderRadius: 10,
  },
})

export const SearchResults = ({
  matchingUsers,
  onUserPress,
  visible,
  maxHeight,
  width,
}: SearchResultsProps): JSX.Element =>
  visible ? (
    <Box
      testID='SearchResultsContainer'
      backgroundColor='white'
      border={{ color: 'greyLight', width: 2 }}
      width={width ?? '100%'}
      maxHeight={maxHeight && maxHeight}
      style={styles.searchResultsContainer}
    >
      <ScrollView style={commonStyles.flexGrow} onScroll={() => Keyboard.dismiss()}>
        {matchingUsers && matchingUsers.length > 0
          ? matchingUsers.map((user) => {
              return <UserRow key={user.id} onUserPress={onUserPress} user={user} />
            })
          : null}
      </ScrollView>
    </Box>
  ) : (
    <></>
  )
